<app-header></app-header>

<!-- Overlay for search by qrcode -->
<div class="overlay-scan-qrcode" [hidden]="!scanQrcode">
  <div class="close-btn" (click)="hideOverlay()">
    <ion-icon name="close-outline" slot="icon-only"></ion-icon>
  </div>
  <div class="content">
    <img src="../../assets/images/qrcode.png" />
    <h1>{{ "ADD_INVITATION.SCAN_QR_CODE_INFO" | translate }}</h1>
  </div>
</div>

<ion-content scrollbar class="ion-content-padding-top-0">
  <ion-fab
    *ngIf="p.renderMobile && page !== 'reception'"
    vertical="bottom"
    horizontal="end"
    slot="fixed"
  >
    <ion-fab-button routerLink="/app/invitation/add-invitation">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <app-list-header
    (toggleFilter)="onToggleFilter()"
    [absoluteFilterButton]="true"
  >
    <ng-container top>
      <div
        class="display-flex ion-align-items-center ion-justify-content-between"
      >
        <div class="invitation__buttons-container">
          <ion-button
            *ngIf="invitationAdd && page !== 'reception' && !p.renderMobile"
            [routerLink]="page === 'reception' ? '' : '/app/invitation/add-invitation'"
          >
            <ion-icon name="add" slot="start"></ion-icon>
            <ion-label>{{ 'INVITATION.BUTTON_ADD' | translate }}</ion-label>
          </ion-button>
        </div>
        <div class="invitation__search-and-rq">
          <app-search-bar
            #searchBar
            class="invitation__search-bar-mobile"
            [permissionEdit]="invitationAdd"
            (searchEvent)="onChangeSearch()"
          >
          </app-search-bar>
          <div class="invitation__buttons-container">
            <ion-button
              fill="outline"
              class="invitation__qr-button"
              *ngIf="!p.renderMobile"
              (click)="onScanQr()"
              slot="end"
            >
              <ion-icon
                color="secondary"
                src="../../assets/icons/qr-code.svg"
                slot="start"
              ></ion-icon>
              <ion-label>
                {{ "INVITATION.BUTTON_SCAN_QR" | translate }}
              </ion-label>
            </ion-button>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container bottom>
      <div
        class="display-flex"
        [ngClass]="page === 'reception' ? 'ion-justify-content-start' : page === 'all' ? 'ion-justify-content-between' : 'ion-justify-content-end'"
        *ngIf="!p.renderMobile"
      >
        <ng-container *ngIf="page === 'all' || page === 'reception'">
          <app-select-dropdown
            class="invitation__company-filter"
            [data]="companyServ.companiesFilter"
            (changeValueEvent)="onFilterCompany($event)"
            placeholder="ADD_INVITATION.COMPANY"
          ></app-select-dropdown>
        </ng-container>

        <ng-container *ngIf="page === 'reception'">
          <app-select-dropdown
            class="invitation__company-filter"
            [data]="invitationServ.devices"
            displayKey="description"
            (changeValueEvent)="onFilterDevice($event)"
            placeholder="ADD_INVITATION.DEVICE"
          ></app-select-dropdown>
          <app-date-time-picker
            pickerType="calendar"
            placeholder="{{ 'ADD_INVITATION.SELECT_DATE' | translate }}"
            (afterPickerClosed)="onFilterDate($event)"
            [value]="selectedDate"
          ></app-date-time-picker>
        </ng-container>
        <ng-container *ngIf="page !== 'reception'">  
          <div class="invitation__range-filter">
            <ng-container *ngIf="invitationServ.currentDateCriterion.id === 'range'">
              <ion-label>
                {{ 'FROM:' | translate }}
              </ion-label>
              <app-date-time-picker
                pickerType="calendar"
                (afterPickerClosed)="invitationServ.filterDetails.dateStart = $event;refreshInvitations()"
                [value]="invitationServ.filterDetails.dateStart"
              ></app-date-time-picker>

              <ion-label>
                {{ 'TO:' | translate }}
              </ion-label>
              <app-date-time-picker
                pickerType="calendar"
                (afterPickerClosed)="invitationServ.filterDetails.dateEnd = $event;refreshInvitations()"
                [value]="invitationServ.filterDetails.dateEnd"
              ></app-date-time-picker>
            </ng-container>
            <span
              class="invitation__dropdowm"
            >
             <app-select-dropdown
                *ngIf="showDropdown"
                [data]="invitationServ.filterDateCriteria"
                [value]="invitationServ.currentDateCriterion"
                (changeValueEvent)="onFilterCrtiterionChanged($event)"
              >
              </app-select-dropdown>
            </span>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </app-list-header>

  <app-pagination-client-side
    *ngIf="page !== 'reception'"
    [ngClass]="{'height-0': showLoader}"
    [columns]="columnsDefinitionInvitations"
    [componentRef]="componentRefInvitations"
    (rowsLoaderReady)="rowsLoaderServiceReadyInvitations($event)"
    [options]="optionsInvitations"
    #invitationPagination
  >
  </app-pagination-client-side>

  <!-- TODO: https://app.clickup.com/t/n976rg wykomentowany przycisk dodawania jak jest pusta lista -->
  <!-- <div
      *ngIf="invitationsFilter?.length == 0 && p.renderMobile && invitationAdd"
      class="display-flex ion-justify-content-center ion-margin-top"
    >
      <ion-button
        [routerLink]="page === 'reception' ? '' : '/app/invitation/add-invitation'"
        size="medium"
      >
        <ion-icon name="add" slot="start"></ion-icon>
        <ion-label>{{ 'INVITATION.BUTTON_ADD' | translate }}</ion-label>
      </ion-button>
    </div> -->

  <app-pagination-client-side
    *ngIf="page === 'reception'"
    [ngClass]="{'height-0': showLoader}"
    [columns]="columnsDefinitionEntry"
    [componentRef]="componentRefEntry"
    (rowsLoaderReady)="rowsLoaderServiceReadyEntries($event)"
    [options]="optionsEntries"
  >
  </app-pagination-client-side>

  <div class="spin" *ngIf="showLoader">
    <app-loading-sti></app-loading-sti>
  </div>
</ion-content>
